'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectedIcon = require('../SelectedIcon');

var _SelectedIcon2 = _interopRequireDefault(_SelectedIcon);

var _fuzzyMatchParser = require('../../../services/fuzzyMatchParser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectOption = function (_PureComponent) {
  _inherits(SelectOption, _PureComponent);

  function SelectOption(props) {
    _classCallCheck(this, SelectOption);

    var _this = _possibleConstructorReturn(this, (SelectOption.__proto__ || Object.getPrototypeOf(SelectOption)).call(this, props));

    _this.setOptionRef = function (node) {
      _this.domNode = node;
    };

    _this.getText = function () {
      var _this$props = _this.props,
          matches = _this$props.matches,
          option = _this$props.option,
          displayKey = _this$props.displayKey;
      // TODO: Replace this with displayKey

      var text = option[displayKey];

      if (matches.length === 0) {
        return text;
      }

      var splitText = (0, _fuzzyMatchParser.parseMatches)(text, matches);
      return splitText.map(function (substr, i) {
        var Component = void 0,
            className = void 0;
        if (substr.highlighted) {
          Component = 'strong';
          className = 'SelectOption-text-matched';
        } else {
          Component = 'span';
          className = 'SelectOption-text-unmatched';
        }

        return _react2.default.createElement(
          Component,
          { key: i, className: className },
          substr.text
        );
      });
    };

    _this.getClassName = function () {
      var _this$props2 = _this.props,
          option = _this$props2.option,
          isSelected = _this$props2.isSelected,
          isHovered = _this$props2.isHovered,
          stylingKey = _this$props2.stylingKey;

      var className = 'SelectOption';

      if (isSelected) {
        className += ' active';
      } else if (isHovered) {
        className += ' hovered';
      }

      if (stylingKey) {
        className += option[stylingKey];
      }

      return className;
    };

    _this.handleClick = function (event) {
      var _this$props3 = _this.props,
          option = _this$props3.option,
          onClick = _this$props3.onClick;

      event.preventDefault();
      event.stopPropagation();
      onClick(option);
    };

    _this.handleHover = function (event) {
      _this.props.onHover(_this.props.option);
    };

    _this.domNode = null;
    return _this;
  }

  _createClass(SelectOption, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isHovered) {
        this.props.scrollTo(this.domNode);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'li',
        {
          ref: this.setOptionRef,
          className: this.getClassName(),
          onClick: this.handleClick,
          onMouseOver: this.handleHover
        },
        _react2.default.createElement(
          'span',
          { className: 'SelectOption-text' },
          this.getText()
        ),
        _react2.default.createElement(_SelectedIcon2.default, { text: this.getText() })
      );
    }
  }]);

  return SelectOption;
}(_react.PureComponent);

SelectOption.propTypes = {
  option: _propTypes2.default.object.isRequired,
  isSelected: _propTypes2.default.bool.isRequired,
  matches: _propTypes2.default.array.isRequired,
  displayKey: _propTypes2.default.string.isRequired,
  stylingKey: _propTypes2.default.string
};

SelectOption.defaultProps = {
  isSelected: false,
  matches: []
};

exports.default = SelectOption;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/SelectOption.js
// module id = 548
// module chunks = 0